import EcontextMobProcess from 'app/components/OrderPayment/Econtext/EcontextMobProcess';
import React from 'react';

const EcontextPaymentMob = () => {
  return <EcontextMobProcess />;
};

export default EcontextPaymentMob;
